<template>
    <g>
        <g transform="translate(670, -490)">
            <logoutButton />
        </g>
        <text
            x="0"
            y="-10"
            class="txt"
            text-anchor="middle"
            dominant-baseline="middle"
            font-family="sans-serif"
            font-size="50"
            fill="#000000"
            >{{ $shared.text.study_closed }}</text
        >
    </g>
</template>

<script>
import logoutButton from "@/v/taskMenu/logoutButton.vue";

export default {
    name: "study_closed",
    components: {
        logoutButton,
    },
};
</script>
